<div class="max-w-[1100px] m-auto">
    <div class="flex flex-col items-center">
        <h1>Student Register</h1>
        @if (loading === false) {
        <form [formGroup]="registerForm" (ngSubmit)="submit(registerForm)" class="flex flex-col items-center">
            @if (createdUsername == null) {
            <mat-card class="self-start my-[30px] p-[20px]">
                <div class="flex flex-wrap items-baseline x-gap-[30px]">
                    <mat-form-field appearance="outline" class="min-w-[260px] mb-[10px]">
                        <mat-label>Student ID</mat-label>
                        <input matInput formControlName="StudentID" maxlength="10" />
                        @if (registerForm.get('StudentID').hasError('required')) {
                        <mat-error>response required</mat-error>
                        }
                        @if (registerForm.get('StudentID').hasError('minlength')) {
                        <mat-error>response too short</mat-error>
                        }
                        @if (registerForm.get('StudentID').hasError('validateNumber')) {
                        <mat-error>response must be a number</mat-error>
                        }
                        <mat-hint>student ID has this form: '530xxxxxxx'</mat-hint>
                    </mat-form-field>
                </div>
                <div class="flex flex-wrap items-baseline x-gap-[30px]">
                    <mat-form-field appearance="outline" class="min-w-[351px] mb-[10px]">
                        <mat-label>Email</mat-label>
                        <input matInput formControlName="Email" required maxlength="100">
                        <mat-hint>use a personal email address that you check regularly</mat-hint>
                        @if (registerForm.get('Email').hasError('required')) {
                        <mat-error>response required</mat-error>
                        }
                        @if (registerForm.get('Email').hasError('email')) {
                        <mat-error>not a valid email</mat-error>
                        }
                    </mat-form-field>
                </div>
                <div class="flex flex-wrap items-baseline x-gap-[30px]">
                    <mat-form-field appearance="outline" class="min-w-[260px] mb-[10px]">
                        <mat-label>Date of Birth</mat-label>
                        <input matInput formControlName="DateOfBirth" required>
                        <mat-hint>required format: mm/dd/yyyy</mat-hint>
                        @if (registerForm.get('DateOfBirth').hasError('required')) {
                        <mat-error>response required</mat-error>
                        }
                        @if (registerForm.get('DateOfBirth').hasError('validateDate')) {
                        <mat-error>date must be in MM/DD/YYYY format</mat-error>
                        }
                    </mat-form-field>
                </div>
                <div class="flex flex-wrap items-baseline x-gap-[30px]">
                    <ng-container formArrayName="PasswordArray">
                        <mat-form-field appearance="outline" class="min-w-[260px] mb-[10px] mr-[10px]">
                            <mat-label>Password</mat-label>
                            <input matInput formControlName="0" type="password" required maxlength="50">
                            @if (passwordComponent.at(0).hasError('required')) {
                            <mat-error>response required</mat-error>
                            }
                            @if (passwordComponent.at(0).hasError('minlength')) {
                            <mat-error>response too short</mat-error>
                            }
                            @if (passwordComponent.at(0).hasError('validatePassword')) {
                            <mat-error>password invalid</mat-error>
                            }
                        </mat-form-field>
                        <mat-form-field appearance="outline" class="min-w-[260px] mb-[10px]">
                            <mat-label>Retype Password</mat-label>
                            <input matInput formControlName="1" type="password" [errorStateMatcher]="matcher" required maxlength="50">
                            @if (passwordComponent.at(1).hasError('required')) {
                            <mat-error>response required</mat-error>
                            }
                            @if (passwordComponent.hasError('validateMatch')) {
                            <mat-error>passwords do not match</mat-error>
                            }
                        </mat-form-field>
                    </ng-container>
                </div>
                <small class="mb-[30px] py-0 px-[16px]">
                    Password must be at least ten characters long and contain at least one of each of the following:
                    <ul>
                        <li>lowercase letter</li>
                        <li>uppercase letter</li>
                        <li>number</li>
                    </ul>
                </small>
            </mat-card>
            }

            @if (formSubmitted === true && registerForm.valid === false) {
            <div class="summary">
                <div>Form is not complete or has invalid responses</div>
            </div>
            }

            <div class="flex flex-col items-center">
                @if (createdUsername == null) {
                <button mat-flat-button type="submit" [disabled]="submitted === true" class="m-[10px]">Submit</button>
                }
                @if (createdUsername != null) {
                <mat-card class="mt-[30px] p-[20px]">
                    <p>Your username for PCPS apps is: {{createdUsername}}</p>
                    <p>This was also emailed to the address you have entered. Do not lose this username or forget the password you entered</p>
                </mat-card>
                }
                <button mat-raised-button type="button" routerLink="/login" class="m-[10px]">Go Back To Login</button>
            </div>
        </form>
        }
    </div>
</div>